import styled from 'styled-components';

export const Background = styled.div`
  background-color: #fff;
  width: 100vw;
  height: 100vh;
`;